/**
 * Resolves the base domain for Cloudflare Workers (verify.*, id.*, etc).
 *
 * Examples:
 * - chat.utua.com.br → utua.com.br → verify.utua.com.br
 * - chat.utua.de → utua.de → verify.utua.de
 * - utua.com.br / utua.mx → same host
 * - localhost / vercel / stage → utua.com.br (fallback)
 */
export default function getHostForWorkers(): string {
  if (typeof window === 'undefined') {
    return 'utua.com.br';
  }

  const hostname = window.location.hostname;
  const isLocalhost = hostname.includes('localhost');
  const isVercel = hostname.includes('vercel');
  const isStage = hostname.includes('stage');

  if (isLocalhost || isVercel || isStage) {
    return 'utua.com.br';
  }

  if (hostname.startsWith('chat.')) {
    return hostname.slice('chat.'.length);
  }

  return hostname;
}
